import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import BrandMarquee from "@/components/BrandMarquee";
import EventDetails from "@/components/EventDetails";
import Manifesto from "@/components/Manifesto";
import Gallery from "@/components/Gallery";
import RegistrationForm from "@/components/RegistrationForm";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="bg-ink" data-testid="landing-page">
      <Navbar />
      <Hero />
      <BrandMarquee />
      <EventDetails />
      <Manifesto />
      <Gallery />
      <RegistrationForm />
      <Footer />
    </div>
  );
}
